import type { CouponList } from "../types";
import CouponListCard from "./CouponListCard";

interface Props {
  data: CouponList;
  sessionToken: string;
}

/* ─── secret_coupon 라우팅 위임 ───────────────────────────────────
 * 시안(ai-lists.html, .ai-gp-coupon--list) 은 Members Only 쿠폰과 일반 쿠폰을
 * 단일 .coupon-list 마크업으로 통합 렌더링한다. 본 컴포넌트는 백엔드 호환성
 * (컴포넌트명 "secret_coupon") 을 유지하면서 CouponListCard 에 위임한다.
 *
 * 쿠폰 적용가능 상품(Eligible Products) 표시는 OMS 가 정식 기능을 제공한 뒤
 * 연동하기로 하여 제거되었다(우리 측 쿠폰 컨디션 역산 표시 중단).
 * ───────────────────────────────────────────────────────────────── */

export default function SecretCouponCard({ data, sessionToken }: Props) {
  // 시크릿 쿠폰 발급 → Go to basket CTA 노출(coupon_list 와 구분).
  return <CouponListCard data={data} sessionToken={sessionToken} variant="secret" />;
}
